import React, { CSSProperties } from 'react';

interface SkeletonProps {
  style?: CSSProperties;
}

const Skeleton = ({ style }: SkeletonProps) => <div className="Skeleton" style={style} />;

export default Skeleton;
